import { render, staticRenderFns } from "./UploadPdf.vue?vue&type=template&id=a6df8642"
import script from "./UploadPdf.vue?vue&type=script&lang=js"
export * from "./UploadPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports